import React, { Component } from "react";
import { connect } from "react-redux";
import qs from "qs";
import _ from "lodash";
import moment from "moment";
import { Link } from "react-router-dom";
import { Button, Alert, Form, Badge, Accordion, Container, Col } from "react-bootstrap";
import Loader from "../components/Loader";
import MobileDetect from "mobile-detect";
import * as ordersActionCreators from "../redux/actions/axis";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import api from "../helpers/apiClient";
import ConfirmModal from "../components/ConfirmModal";
import ReactTooltip from "react-tooltip";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, } from '@fortawesome/fontawesome-svg-core/import.macro'
import promptIcon from '../images/adminPrompt.svg';
import TabHeader from '../components/TabHeader';
import Promise from "bluebird";
import Dropzone from 'react-dropzone'

const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;
const country = window.location.hostname === 'seller.giftr.my' ? 'MY' : 'SG'

const fulfillmentStatusOptions = {
  any: "Any",
  fulfilled: "Fulfilled",
  unfulfilled: "Unfulfilled"
};

class Axis extends Component {
  constructor(props) {
    super(props);
    const { user } = props;
    const { location } = props;
    let fulfillmentStatus = "any";
    let vendor = "any";
    let startDate, endDate;
    let orderPeriodStart = moment().subtract(2, 'months')
    let orderPeriodEnd = moment()
    // let order_period =
    //   user.role === "admin" || user.role === "staff" ? "2" : "3";
    let forceSyncClicked = false;
    let selectedIds = [];
    let showWarningModal = false;
    let orderId = ""
    if (location.search) {
      const { financial_status, fulfillment_status } = qs.parse(
        location.search.substr(1)
      );
      const queryString = qs.parse(location.search.substr(1));

      if (queryString.vendor) {
        vendor = queryString.vendor;
      }
      if (queryString.fulfillment_status) {
        fulfillmentStatus = queryString.fulfillment_status;
      }
      if (queryString.start_date) {
        startDate = moment(queryString.start_date, "D-M-YY");
      }
      if (queryString.end_date) {
        endDate = moment(queryString.end_date, "D-M-YY");
      }
      if (queryString.order_period_start) {
        orderPeriodStart = moment(queryString.order_period_start, "D-M-YY");
      }
      if (queryString.order_period_end) {
        orderPeriodEnd = moment(queryString.order_period_end, "D-M-YY");
      }
      if (queryString.order_id) {
        orderId = queryString.order_id
      }
    }

    this.state = {
      fulfillmentStatus,
      vendor,
      startDate,
      endDate,
      forceSyncClicked,
      selectedIds,
      showWarningModal,
      orderPeriodStart,
      orderPeriodEnd,
      orderId
    };
  }

  componentDidMount() {
    const { fetchOrders, location, user, fetchMerchants } = this.props;
    const { orderPeriodStart, orderPeriodEnd } = this.state;
    const {
      merchantId,
      financial_status,
      fulfillment_status,
      limit,
      createdAtMax,
      start_date,
      end_date,
      vendor,
      order_period_start,
      order_period_end,
      order_id
    } = qs.parse(location.search.substr(1));

    fetchOrders(
      merchantId ? merchantId : vendor,
      financial_status,
      fulfillment_status,
      limit,
      createdAtMax,
      start_date,
      end_date,
      order_period_start ? order_period_start : orderPeriodStart.format("D-M-YY"),
      order_period_end ? order_period_end : orderPeriodEnd.format("D-M-YY"),
      order_id
    );
  }
  //fetchOrders(merchantId ? merchantId : vendor, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date, order_period ? order_period : defaultOrderPeriod)

  componentWillReceiveProps(nextProps) {
    const { location: prevLocation, user } = this.props;
    const { orderPeriodStart, orderPeriodEnd } = this.state;
    const { fetchOrders, location } = nextProps;
    if (location.search !== prevLocation.search) {
      const {
        merchantId,
        financial_status,
        fulfillment_status,
        limit,
        createdAtMax,
        start_date,
        end_date,
        vendor,
        order_period_start,
        order_period_end,
        order_id
      } = qs.parse(location.search.substr(1));

      let adminPrompt = false;
      if (!vendor && ["admin", "staff"].includes(user.role)) {
        adminPrompt = true;
      }

      this.setState({
        adminPrompt,
        vendor: vendor || "any",
        fulfillmentStatus: fulfillment_status || "any",
      });

      if (!adminPrompt) {
        fetchOrders(
          merchantId ? merchantId : vendor,
          financial_status,
          fulfillment_status,
          limit,
          createdAtMax,
          start_date,
          end_date,
          order_period_start ? order_period_start : orderPeriodStart.format("D-M-YY"),
          order_period_end ? order_period_end : orderPeriodEnd.format("D-M-YY"),
          order_id
        );
      }

      // fetchOrders(merchantId ? merchantId : vendor, financial_status, fulfillment_status, limit, createdAtMax, start_date, end_date, order_period ? order_period : 3);
    }
  }

  renderDetailLink = (cell, row) => {
    return (
      <Link
        key={row.id}
        to={{
          pathname: row.manual_order
            ? `/manual_orders/${row.manual_order_id}`
            : `/orders/${row.id}`,
          // state: {modal: true}
        }}
      >
        {row.name}
      </Link>
    );
  };

  renderFulfillmentStatus = (cell, row) => {
    if (row.cancelled_at || row.line_item_cancelled || row.fulfillment_status == 'cancelled') {
      return (
        <Badge bg="danger text-uppercase">Cancelled</Badge>
      );
    } else if (_.lowerCase(row.fulfillment_status) === "fulfilled") {
      return (
        <Badge bg="success text-uppercase">
          {row.fulfillment_status || "Unfulfilled"}
        </Badge>
      );
    } else if (row.fulfillment_status) {
      return (
        <Badge bg="warning text-uppercase">
          {row.fulfillment_status}
        </Badge>
      );
    } else {
      return (
        <Badge bg="warning text-uppercase">Unfulfilled</Badge>
      );
    }
  };


  renderSelectFilter = (options, defaultValue, onChange) => {
    return (
      <Form.Select className="form-control" onChange={onChange} value={defaultValue}>
        {Object.keys(options).map((key) => {
          return (
            <option key={key} value={key}>
              {options[key]}
            </option>
          );
        })}
      </Form.Select>
    );
  };

  handleResetFilter = () => {
    const { user } = this.props;

    this.setState({
      vendor: "any",
      fulfillmentStatus: "any",
      startDate: null,
      endDate: null,
      orderPeriodStart: moment().subtract(2, 'months'),
      orderPeriodEnd: moment()
    });
  }

  handleOnClickFilter = () => {
    const {
      history,
      location: { pathname },
    } = this.props;
    const {
      fulfillmentStatus,
      startDate,
      endDate,
      orderPeriodStart,
      orderPeriodEnd,
      vendor,
      orderId
    } = this.state;

    let startDateShortFormat, endDateShortFormat;
    if (startDate) {
      startDateShortFormat = startDate.format("D-M-YY");
    }

    if (endDate) {
      endDateShortFormat = endDate.format("D-M-YY");
    }

    let orderPeriodStartShortFormat, orderPeriodEndShortFormat
    if (orderPeriodStart) {
      orderPeriodStartShortFormat = orderPeriodStart.format("D-M-YY");
    }

    if(orderPeriodEnd){
      orderPeriodEndShortFormat = orderPeriodEnd.format("D-M-YY");
    }

    const queryString = qs.stringify({
      // merchantId,
      start_date: startDateShortFormat,
      end_date: endDateShortFormat,
      fulfillment_status: fulfillmentStatus,
      vendor,
      order_period_start: orderPeriodStartShortFormat,
      order_period_end: orderPeriodEndShortFormat,
      order_id: orderId
    });
    history.push(`${pathname}?${queryString}`);

    this.setState({ selectedIds: [] });
  }

  handleEnter = e => {
    if (e.key === 'Enter') {
      this.handleOnClickFilter();
    }
  }

  handleOnClickForceSync = () => {
    this.setState({
      forceSyncClicked: true,
    });

    return api(`/orders/force/sync`, {
      method: "POST",
    }).then((res) => {
      console.log("sync", res);
    });
  };

  handleOnFulfillmentStatusChange = (e) => {
    this.setState({ fulfillmentStatus: e.target.value });
  };

  handleOnInputChange = (e) => {

    const { name, value, type } = e.target;

    this.setState({
      [name]: value
    });
  }

  handleOnVendorChange = (e) => {
    this.setState({ vendor: e.target.value });
  };

  deliveryDateSort = (date1, date2, order) => {

    if (!date1) {
      date1 = "01/01/2010";
    }

    if (!date2) {
      date2 = "01/01/2010";
    }

    if (order === "desc") {
      return moment(date2, "DD/MM/YYYY").unix() - moment(date1, "DD/MM/YYYY").unix();
    } else {
      return moment(date1, "DD/MM/YYYY").unix() - moment(date2, "DD/MM/YYYY").unix();
    }
  };

  dateSort = (date1, date2, order) => {

    if (!date1) {
      date1 = "01/01/2010";
    }

    if (!date2) {
      date2 = "01/01/2010";
    }

    if (order === "desc") {
      return (
        moment(date2, "DD/MM/YYYY").unix() - moment(date1, "DD/MM/YYYY").unix()
      );
    } else {
      return (
        moment(date1, "DD/MM/YYYY").unix() - moment(date2, "DD/MM/YYYY").unix()
      );
    }
  };

  priceSort = (price1, price2, order) => {
    price1 = Number(price1);
    price2 = Number(price2);

    if (!price1) {
      price1 = 0
    }

    if (!price2) {
      price2 = 0
    }

    if (order === 'desc') {
      return price2 - price1
    } else {
      return price1 - price2
    }
  }

  onRowSelect = (row, isSelected, e) => {
    let { selectedIds } = this.state;

    if (isSelected) {
      selectedIds.push(row);
    } else {
      selectedIds = selectedIds.filter(r => r._id !== row._id);
    }

    this.setState({ selectedIds });
  };

  onSelectAll = (isSelected, rows) => {
    let { selectedIds } = this.state;

    selectedIds = []
    if (isSelected) {
      _.each(rows, function (row) {
        selectedIds.push(row)
      })
    }

    this.setState({ selectedIds });

    return true;
  };

  handleOnCloseWarningModal = () => {
    this.setState({ showWarningModal: false });
  }

  renderDate = (cell, row) => {
    return cell ? moment(cell).format("DD/MM/YYYY") : ''
  }

  renderPrice = (cell, row) => {
    return  `${parseInt(cell).toFixed(2)}` 
  }

  handleVoucherClick = async (url, row) => {
    try {
      await api('/logs', {
        method: 'POST',
        body: JSON.stringify({
          type: 'View Voucher',
          axisPONumber: row.axisPONumber,
          sku: row.productSKU
        })
      });
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error logging voucher view:', error);
      // Still open the voucher even if logging fails
      window.open(url, '_blank');
    }
  }

  renderVoucher = (cell, row) => {
    return cell ? 
      <a href="#" onClick={(e) => {
        e.preventDefault();
        this.handleVoucherClick(cell, row);
      }}>View</a> : ''
  }

  handleOnDrop = (acceptedFiles) => {
    const { selectedIds } = this.state;
    const { fetchOrders } = this.props;
    const { location: { pathname } } = this.props;

    let formData = new FormData();
    formData.append('voucher', acceptedFiles[0]);
    formData.append('items', JSON.stringify(selectedIds));

    return api(`/axis/upload/voucher`, {
      method: "POST",
      body: formData
    }, {'Accept': 'application/json'}).then((res) => {
      fetchOrders();
      this.setState({selectedIds: []})
    });
  }

  handleOnClickDelete = () => {

    //pop up modal to confirm delete
    this.setState({ showWarningModal: true });
  }

  handleDeletePurchaseOrders = () => {
    const { selectedIds } = this.state;
    const { fetchOrders } = this.props;

    return api(`/axis/po`, {
      method: "DELETE",
      body: JSON.stringify({ items: selectedIds })
    }).then((res) => {
      this.setState({ showWarningModal: false, selectedIds: [] });
      fetchOrders();
    });
  }

  render() {
    const {
      orders: { loading, loaded, items, next },
      location: { pathname, search, routeState },
      previousRoutes,
      previousPreviousRoutes,
      previousRoutePathName,
      previousRouteSearch,
      user,
      merchantsOptions,
    } = this.props;
    const {
      fulfillmentStatus,
      vendor,
      forceSyncClicked,
      selectedIds,
      adminPrompt,
      showWarningModal,
      orderId,
      parcels,
    } = this.state;

    const isAdmin = user.role === "admin";
    const isStaff = user.role === "staff";
    const isMobile =
      new MobileDetect(window.navigator.userAgent).mobile() !== null;

    let unselectable = [];
    let virtualMessage = false;

    _.each(items, (item) => {
      const { line_item_id, line_item_fulfilled, line_item_cancelled, line_item_properties } = item
      const line_item_vm = _.find(line_item_properties, p => p.name === 'Audio/Video Message')

      if(line_item_fulfilled || line_item_cancelled){// || !item.delivery){
        unselectable.push(line_item_id)
      }
      if(line_item_vm){
        virtualMessage = true
      }
    });

    const ids = _.map(selectedIds, item => {
      return item._id
    })

    let selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      selected: ids,
      onSelect: this.onRowSelect,
      onSelectAll: this.onSelectAll,
      nonSelectable: unselectable,
      headerColumnStyle: { width: '30px' },
    };

    const ordersCol = [
      {
        dataField: 'orderDate',
        text: 'Order Date',
        sort: true,
        formatter: this.renderDate,
        headerStyle: {
          width: '100px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'axisPONumber',
        text: 'Axis PO Number',
        headerStyle: {
          width: '150px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'brand',
        text: 'Brand',
        sort: true,
        headerStyle: {
          width: '120px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'productSKU',
        text: 'Product SKU',
        headerStyle: {
          width: '180px',
          resize: 'horizontal'
        },
      },
      {
        dataField: 'totalQuantity',
        text: 'Quantity',
        headerStyle: {
          width: '80px',
          resize: 'horizontal'
        }
      },
      {
        dataField: 'denomination',
        text: 'Denomination (RM)',
        formatter: this.renderPrice,
        headerStyle: {
          width: '80px',
          resize: 'horizontal'
        }
      },
      {
        dataField: 'orderValue',
        text: 'Order Value',
        formatter: this.renderPrice,
        headerStyle: {
          width: '80px',
          resize: 'horizontal'
        }
      },
      {
        dataField: 'voucher',
        text: 'Voucher',
        formatter: this.renderVoucher,
        headerStyle: {
          width: '80px',
          resize: 'horizontal'
        }
      }
    ];

    const options = {
      showTotal: true,
      sizePerPage: 20,
      sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }, {
        text: 'All', value: items.length
      }],
    };

    const searchPlaceholder = window.location.hostname === 'seller.giftr.my' ? 'GTR83000' : 'GSR3400'

    return (
      <div>
        <TabHeader title="Axis POs" tab_id="po" user={user} />        

        <Accordion style={{borderRadius: '18px'}} className="dashboard-card shadow-sm" defaultActiveKey="0">
          <Accordion.Item style={{borderRadius: '18px', border: 'none'}} eventKey="0">
            <Accordion.Header><h5 style={{marginBottom: '0'}}>Filters</h5></Accordion.Header>
            <Accordion.Body>
              <div className="row">
                <div className="col-sm-9">
                  <div className="row">
                    <div className="col-xs-12 col-sm-5 col-xl-3 mb-3 mb-sm-3">
                      <label style={{marginBottom: '5px'}}>Fullfillment</label>
                      {this.renderSelectFilter(
                        fulfillmentStatusOptions,
                        fulfillmentStatus,
                        this.handleOnFulfillmentStatusChange
                      )}
                    </div>
                    <div className="d-grid col-xs-12 col-sm-7 col-xl-5 mb-3 mb-sm-3">
                      <label style={{marginBottom: '5px'}}>Order Period</label>
                      <DateRangePicker
                        small
                        minimumNights={0}
                        numberOfMonths={1}
                        displayFormat="D/M/YY"
                        showClearDates={false}
                        showDefaultInputIcon={true}
                        isOutsideRange={() => false}
                        startDate={this.state.orderPeriodStart} // momentPropTypes.momentObj or null,

                        startDateId="orders-period-start"
                        endDate={this.state.orderPeriodEnd} // momentPropTypes.momentObj or null,
                        endDateId="orders-period-end"
                        onDatesChange={({ startDate, endDate }) => {
                          this.setState({ orderPeriodStart: startDate, orderPeriodEnd: endDate })
                        }
                        } // PropTypes.func.isRequired,
                        focusedInput={this.state.focusedInput1} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                        onFocusChange={(focusedInput1) =>
                          this.setState({ focusedInput1 })
                        } // PropTypes.func.isRequired,
                      />
                    </div>
                  </div>
                  <div className="row">
                    

                  </div>
                </div>

                <div className="filter-buttons col-sm-3 d-flex flex-sm-column flex-lg-row justify-content-between my-2 mb-auto">
                <Button
                    className="apply-filter col-xs-6 mx-2 mb-2 mb-lg-0"
                    variant="secondary"
                    style={{width: '100%'}}
                    onClick={this.handleResetFilter}
                  >Reset
                  </Button>
                <Button
                    className="apply-filter col-xs-6 mx-2 mb-2 mb-lg-0"
                    variant="primary"
                    style={{width: '100%'}}
                    onClick={this.handleOnClickFilter}
                  >Apply
                  </Button>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        { 
          isAdmin &&
          <Container fluid className="my-3 d-flex gap-3 flex-column flex-sm-row-reverse flex-wrap align-items-lg-end">
            <Col sm="auto">
              <Dropzone
                className='dropzone-area'
                onDrop={this.handleOnDrop}
                multiple={false}
                accept='image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'>
                  <Button
                    variant="primary"
                    disabled={selectedIds.length < 1}
                    className="w-100 btn-br-6"
                    onClick={this.handleOnClickMergeShipment}
                  >
                    Upload voucher
                  </Button>
              </Dropzone> 
            </Col>
            <Col sm="auto">
              <Button
                variant="primary"
                disabled={selectedIds.length < 1}
                className="w-100 btn-br-6"
                onClick={this.handleOnClickDelete}
              >
                Delete
              </Button>
            </Col>
          </Container>
        }
        <div className="clearfix"></div>
        {loading && <Loader />}
        {adminPrompt && (
          <div className="admin-prompt">
            <img src={promptIcon}></img>
            <h3 className="mb-0">Please select filter options</h3>
          </div>
        )}
        {!loading && items && !adminPrompt && (
          <>
            <ToolkitProvider
              keyField='_id'
              data={items}
              columns={ordersCol}
              exportCSV={{
                exportAll: false
              }}
              search
            >
              {
                props => (
                  <>
                    <Container fluid className="mb-3 mt-4 d-flex gap-3 flex-row flex-wrap">
                      <Col>
                        { !isStaff &&
                        <ExportCSVButton
                          className="btn-info"
                          style={{borderRadius:'8px'}}
                          { ...props.csvProps }
                        ><FontAwesomeIcon icon={solid('arrow-right-from-bracket')} transform="rotate--90" style={{marginRight: '15px'}}/>
                          Export to CSV</ExportCSVButton>
                        }
                      </Col>
                      <Col xs={4}>
                        <SearchBar { ...props.searchProps }
                        style={{borderRadius:'25px'}} placeholder="Search"/>
                      </Col>
                    </Container>
                    <BootstrapTable
                      { ...props.baseProps }
                      bordered={ false }
                      selectRow={selectRowProp}
                      pagination={paginationFactory(options)}
                      hover
                      defaultSorted={[{
                        dataField: 'created_at',
                          order: 'desc',
                      }]}
                      noDataIndication={() => 'There is no data to display'}
                    />
                  </>
                )
              }
            </ToolkitProvider>
          </>
        )}
        {
          showWarningModal &&
          <ConfirmModal
            onClose={this.handleOnCloseWarningModal}
            noBtnTitle="Cancel"
            yesBtnTitle="Delete"
            onClickYes={this.handleDeletePurchaseOrders}
            title="Delete Purchase Orders">
            <p>Are you sure you want to delete {selectedIds.length} purchase order(s)?<br/></p>
          </ConfirmModal>
        }
      </div>
    );
  }
}

const defaultOptions = [{ key: "any", value: "any", name: "Any" }];

export default connect(
  (state, props) => {
    const { pathname, search, routeState } = props.location;
    let previousRoutePathName;
    let previousRouteSearch;
    if (
      routeState &&
      routeState.previousRoutes &&
      routeState.previousRoutes.length
    ) {
      const previousRoute =
        routeState.previousRoutes[routeState.previousRoutes.length - 1];
      previousRoutePathName =
        previousRoute.indexOf("?") > -1
          ? previousRoute.substr(0, previousRoute.indexOf("?"))
          : previousRoute;
      previousRouteSearch =
        previousRoute.indexOf("?") > -1
          ? previousRoute.substr(previousRoute.indexOf("?"))
          : null;
    }
    return {
      user: state.auth.user,
      orders: state.orders,
      previousRoutePathName,
      previousRouteSearch,
      previousRoutes:
        routeState &&
        routeState.previousRoutes &&
        routeState.previousRoutes.length
          ? [...routeState.previousRoutes, `${pathname}${search}`]
          : [`${pathname}${search}`],
      previousPreviousRoutes:
        routeState &&
        routeState.previousRoutes &&
        routeState.previousRoutes.length
          ? routeState.previousRoutes.slice(
              0,
              routeState.previousRoutes.length - 1
            )
          : null,
    };
  },
  { ...ordersActionCreators }
)(Axis);
